import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { numberFormatter } from "../utils/utils";
import { MIN_PERCENTAGE_TO_SHOW } from "../utils/const";

const withPercentageBlock = (Component: React.ComponentType<any>) => {
  return ({ percentage, ...props }: { percentage: number }) => {
    const theme = useTheme();

    const [averageToFormat, setAverageToFormat] = useState(
      percentage >= MIN_PERCENTAGE_TO_SHOW || percentage <= -MIN_PERCENTAGE_TO_SHOW
        ? percentage
        : 0,
    );
    const [value, setValue] = useState(
      numberFormatter.format(+Math.abs(averageToFormat * 100).toFixed(1)) == "0"
        ? "0.0"
        : (+numberFormatter.format(+Math.abs(averageToFormat * 100).toFixed(1))).toFixed(1),
    );
    const [arrowDirection, setArrowDirection] = useState(
      averageToFormat !== 0 ? (percentage < 0 ? "down" : "up") : "none",
    );

    useEffect(() => {
      const averageToFormat =
        percentage >= MIN_PERCENTAGE_TO_SHOW || percentage <= -MIN_PERCENTAGE_TO_SHOW
          ? percentage
          : 0;
      const unFixedValue = numberFormatter.format(+Math.abs(averageToFormat * 100).toFixed(1));
      setAverageToFormat(averageToFormat);
      setValue(unFixedValue == "0" ? "0.0" : (+unFixedValue).toFixed(1));
      setArrowDirection(averageToFormat !== 0 ? (percentage < 0 ? "down" : "up") : "none");
    }, [percentage]);

    return (
      <Component
        averageToFormat={averageToFormat}
        value={value}
        arrowDirection={arrowDirection}
        {...props}
      />
    );
  };
};

export default withPercentageBlock;
